export const root = '/'
export const servicePath = 'https://whelam.nouraboelsoud.com/apis/public/';
